import { Browser, detect } from 'detect-browser';

const useBrowserDetect = (browserName: Browser): boolean => detect()?.name === browserName;

export default useBrowserDetect;
